// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert,
  Table
}                     from 'react-bootstrap';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createHashHistory } from 'history';
import { withRouter, Link } from 'react-router-dom';

import isEmpty from 'lodash.isempty';
import Pagination from 'react-paginating';

import '../dashboard/dashboard.scss';
import CountryStateCity from '../../../components/countryStateCity/CountryStateCity';
import { voucherStatus } from '../../../redux/actions/frontActions';
import logo from '../../../img/ddb-logo.png';

import { Notification } from '../../../components/notifications';

import {renderAlert,clearAlert} from '../../../redux/actions/alertsActions';
import NumberFormat from "react-number-format";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

let Recaptcha = require('react-recaptcha');

const history = createHashHistory();
let cart='';
class Redeem extends Component {
  constructor(props, context){
    super(props, context);
    this.state = {
      email: '',
      orderID: '',
      showAlert: false,
      disabled:false,
      orderList: '',
      hover: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear=this.Clear.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  handleChange = (e) => {
    this.setState({[e.target.name] : e.target.value});

    if(`${e.target.name}Error` !== ''){
      this.setState({[`${e.target.name}Error`]:''})
    }
    this.setState({ disabled: false });
  }

  handleDismiss() {
    this.setState({ showAlert: false });
  }

  handleShow() {
    this.setState({ showAlert: true });
  }

  Clear(){
    this.setState({
      voucherNumber: "",
    });
  }

  componentWillMount() {
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }

    let voucherIDParams = this.props.route.match.params.voucherID ? this.props.route.match.params.voucherID : '';
    if(voucherIDParams){
      this.setState({voucherNumber: voucherIDParams});
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }

    if(this.props.orderRedeem != nextProps.orderRedeem){
    	if(nextProps.orderRedeem){
        this.setState({disabled:false})
    		this.setState({showAlert:true})
        this.handleShow();
        this.props.renderAlert('success', nextProps.orderRedeem.message);
        window.scrollTo(0, 0);
    	}
    }

    if(this.props.error != nextProps.error){
      if(nextProps.error){
        this.setState({showAlert:true})
        this.setState({disabled:false})
        this.handleShow();
        this.props.renderAlert('warning', nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    if(this.props.message !== nextProps.message){
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
        //Clear();
    }

    

  }

  componentWillUpdate(nextProps, nextState){
  }

  validate = () => { 
    let isError = false;
    const errors = {};

    if(!this.state.voucherNumber){
      isError = true;
      this.setState({voucherNumberError:"red"})
    }

    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const err = this.validate();
 
    if(!err){
      this.setState({disabled:true})
      this.props.voucherStatus({voucherNumber: this.state.voucherNumber});
    }
  }

 render() {
    return(
      <div> 
          <form onSubmit={this.handleSubmit}>            
            <div className="container">
                <Col md={6} mdOffset={3}>
	                <div className="panel margin-top">
	                  <header className="panel-heading text-center text-default">Redeem Voucher</header>
	                  <div className="panel-body">
	                    {this.state.showAlert && this.state.alertMessage !=='' &&        
	                      <div className="col-lg-12">
	                        <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
	                          <strong>{(this.state.msgType === 'warning') ? 'Warning' : 'Success' } :</strong> {this.state.alertMessage}
	                        </Alert>
	                      </div>
	                    }
	                    <Row>
	                      <Col md={12} xs={12}>
	                        <FormGroup>
	                          <ControlLabel>Voucher Number</ControlLabel>
	                          <FormControl
	                            type="text"
	                            value={this.state.voucherNumber}
	                            placeholder="Voucher Number"
	                            onChange={this.handleChange}
	                            style={{borderColor:this.state.voucherNumber}}
	                            name="voucherNumber"
	                            autoComplete="off"
                              required
	                          />
	                        </FormGroup>
                          
	                      </Col>
	                    </Row> 
	                    <Row>
		                  <Col md={12} xs={12}>
		                    <Button 
                          bsStyle="success" 
                          style={{backgroundColor: (this.state.hover && this.state.hoverID == 'order') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                          data-id = {'order'}
                          onMouseEnter={this.hoverOn} 
                          onMouseLeave={this.hoverOff}
                          type="submit" 
                          disabled={this.state.disabled}
                        >
                          Redeem
                        </Button>
		                  </Col>
		                </Row>
	                  </div>
	                </div>
                </Col>
            </div>
          </form>
      </div>
    );
  }
}


Redeem.propTypes = {
 voucherStatus: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  error: state.frontReducer.error,
  orderRedeem: state.frontReducer.ordertracking,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
})



export default compose(
  connect(mapStateToProps,{voucherStatus, renderAlert, clearAlert})
)(Redeem);



// WEBPACK FOOTER //
// ./src/app/views/frontend/user/Redeem.js